import * as CONSTANTS from './constants'

/**
 * This object is used to prepare cost data for client
 */
export class StatusReport {
    totalInfectedCost;
    totalShutoffCost;
    notifyImpact;
    nodesThatWereShutoff;
    shutdownEdges;
    allInfectedNodes;
    totalIsolationCost;

    /** 
     * Factory function builds a Status Report and prepares data for client by calculating costs
     * @param {Storage} storage
     * @param shutoffNodes
     * @param shutdownEdges
     * @param allInfectedNodes
     * @param {number} notifyImpact
     * @param {bool} inProgress = true
     * @return {StatusReport} instance
     */
    static build(storage, shutoffNodes, shutdownEdges, allInfectedNodes, notifyImpact, inProgress = true) {
        let instance = new StatusReport();
        instance.totalInfectedCost = 0;
        instance.totalShutoffCost = 0;
        instance.totalIsolationCost = 0;
        instance.notifyImpact = notifyImpact;
        for (let node of Object.values(storage.getNodeDatas())) {
            if (!inProgress && node.getPublicStatus() === CONSTANTS.COMPROMISED) {
                instance.totalInfectedCost += node.getCostInfected();
            }
            else if (inProgress && node.isInvestigated() && node.isInfected()) {
                instance.totalInfectedCost += node.getCostInfected();
            }
            if (node.isOff()) {
                instance.totalShutoffCost += node.getCostShutoff();
            }
            // TODO: figure out how notify impact cost is upposed to work inside of the nodes
        }
        instance.nodesThatWereShutoff = shutoffNodes;
        instance.shutdownEdges = shutdownEdges;
        instance.allInfectedNodes = allInfectedNodes;
        return instance;
    }

    /**
     * Sum cost values together and @return totalCost
     * @return {number} totalCost
     */
    getTotalCost() {
        return this.totalInfectedCost + this.totalShutoffCost + this.totalIsolationCost - this.notifyImpact;
    }

    /**
     * convert data stored in StatusReport to an array readable by client
     * @return {Object} 
     */
    asArray() {
        return {
            'totalLossFromInfection': this.getTotalInfectedCost(), 
            'totalLossFromShutoff': this.getTotalShutoffCost(),
            'savingsFromNotifications': this.getNotifyImpact(),
            'totalIncurredLoss': this.getTotalCost(),
            'shutOffNodes': this.nodesThatWereShutoff,
            'disconnectedEdges': this.shutdownEdges,
            'infectedNodes': this.allInfectedNodes
        }
    }

    getTotalInfectedCost() {
        return this.totalInfectedCost;
    }

    getTotalShutoffCost() {
        return this.totalShutoffCost;
    }

    getNotifyImpact() {
        return this.notifyImpact;
    }

    setTotalInfectionCost(cost) {
        this.totalInfectedCost = cost;
    }

    setTotalShutoffCost(cost) {
        this.totalShutoffCost = cost;
    }

    setNotifyImpact(cost) {
        this.notifyImpact = cost;
    }
}